import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "input-form" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-box" }
const _hoisted_4 = { class: "input-tip" }

import { ref, inject } from 'vue';
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/store';
import PopupForm from '@/components/PopupForm.vue';
import { bindCode } from '@/api';


export default {
  __name: 'BindSuperior',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const MyToast = inject('myToast')

const { t } = useI18n()
const userStore = useUserStore()

const referralCode = ref('');

const doBind = () => {
  bindCode({ code: referralCode.value }).then(res => {
    MyToast({ type: 'success', message: t('notify.operateSuccess') });
    emit('onClose');
    userStore.loadUserInfo();
  })
}

return (_ctx, _cache) => {
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_button = _resolveComponent("van-button")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createBlock(PopupForm, {
    title: _ctx.$t('user.bindSuperior'),
    onOnClose: _cache[1] || (_cache[1] = $event => (emit('onClose')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_field, {
              modelValue: referralCode.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((referralCode).value = $event)),
              class: "input-field text-center",
              placeholder: _ctx.$t('placeholder.referralCode')
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('user.bindTip')), 1),
        _withDirectives((_openBlock(), _createBlock(_component_van_button, {
          class: "submit-btn",
          disabled: !referralCode.value,
          onClick: doBind
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])), [
          [_directive_audio]
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

}